<template>
  <div>
    <v-dialog v-model="data.dialog" width="440" :persistent="true">
      <div class="confirm-dialog-card">
        <div class="confirm-icon-wrap">
          <v-icon size="24" color="#0277BD">{{icon ? icon : `mdi-alert`}}</v-icon>
        </div>
        <p class="confirm-dialog-title">{{title ? title : $t('areYouSure')}}</p>
        <p class="confirm-dialog-desc">{{ $t('operationCannotBeUndone') }}</p>
        <div class="confirm-dialog-text" v-if="text" v-html="text"/>
        <div class="confirm-dialog-actions">
          <button type="button" class="confirm-cancel-btn" :disabled="loading" @click="data.dialog = false">
            {{$t('cancel')}}
          </button>
          <button type="button" class="confirm-confirm-btn" :disabled="loading" @click="confim">
            <span class="confirm-spinner" v-if="loading"></span>
            <span v-else>{{$t('toConfirm')}} <v-icon size="16" color="#FFFFFF" class="ml-1">mdi-check</v-icon></span>
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    name: 'ConfirmOperation',
    props: ['data', 'confimAction', 'text', 'title', 'icon'],
    components: {
  },
    data: () => ({
      loading: false
    }),
    mounted: function() {
    },
    computed: {
    },
    methods: {
      confim: function() {
        this.data.dialog = false
        this.confimAction()
      }
    }
  }
</script>
<style scoped>
.confirm-dialog-card {
  background: #FFFFFF;
  border-radius: 1.5rem;
  font-family: 'Montserrat', sans-serif;
  padding: 1.75rem 1.5rem 1.5rem;
  text-align: center;
}
.confirm-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #E3F1FA;
  margin: 0 auto 1rem;
}
.confirm-dialog-title {
  font-weight: 800;
  font-size: 1.05rem;
  color: #101827;
  margin: 0 0 0.35rem;
}
.confirm-dialog-desc {
  color: #5B6472;
  font-size: 0.85rem;
  margin: 0;
}
.confirm-dialog-text {
  color: #5B6472;
  font-size: 0.85rem;
  margin-top: 0.5rem;
}
.confirm-dialog-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1.5rem;
}
.confirm-cancel-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(16,24,39,0.12);
  border-radius: 999px;
  background: transparent;
  color: #101827;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background 0.2s ease;
}
.confirm-cancel-btn:hover:not(:disabled) {
  background: rgba(16,24,39,0.05);
}
.confirm-cancel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.confirm-confirm-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.75rem 1rem;
  box-shadow: 0 8px 18px rgba(2, 119, 189, 0.28);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.confirm-confirm-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.38);
}
.confirm-confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}
.confirm-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.4);
  border-top-color: #FFFFFF;
  animation: confirm-spin 0.7s linear infinite;
}
@keyframes confirm-spin {
  100% { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  .confirm-spinner {
    animation: none;
  }
}
</style>
